// extracted by mini-css-extract-plugin
module.exports = {"no-wrap-word":"TransWithNoWrapSpan_no-wrap-word__23BXm"};